/* Choose a fresh, unique subset without downloading the unselected template images. */
function eirasRandomSubset(items, limit, random = Math.random) {
 const pool = [...items];
 for (let i = pool.length - 1; i > 0; i--) {
  const j = Math.floor(random() * (i + 1));
  [pool[i], pool[j]] = [pool[j], pool[i]];
 }
 return pool.slice(0, limit);
}
(() => {
 function init(root = document) {
  root.querySelectorAll('[data-eiras-random-grid]').forEach(grid => {
   if (grid.dataset.randomReady) return;
   const template = grid.nextElementSibling;
   if (!template?.matches('template[data-eiras-product-pool]')) return;
   const selected = eirasRandomSubset(template.content.children, Number(grid.dataset.limit) || 5);
   if (!selected.length) return;
   grid.replaceChildren(...selected.map(card => card.cloneNode(true)));
   grid.dataset.randomReady = 'true';
  });
 }
 document.addEventListener('shopify:section:load', event => init(event.target));
 init();
})();
/* Show honest verification guidance without intercepting Shopify's secure submission. */
document.addEventListener('click', event => {
  const submit = event.target.closest('button[type="submit"], input[type="submit"]');
  const form = submit?.form;
  const status = form?.querySelector('[data-ei-contact-status]');
  if (status && form.checkValidity()) status.hidden = false;
}, true);
/* Device-local favourites and history. No external services or tracking. */
(() => {
  if (window.eirasInitialized) return;
  window.eirasInitialized = true;
  const root = document.body.dataset.eirasRoot || '/';
  const key = kind => `eiras-${kind}-v1`;
  const read = kind => { try { const items=JSON.parse(localStorage.getItem(key(kind)) || '[]'); return Array.isArray(items) ? items.filter(x=>typeof x==='string' && /^[a-z0-9-]+$/.test(x)).slice(0,24) : []; } catch { return []; } };
  const save = (kind, values) => { try { localStorage.setItem(key(kind), JSON.stringify(values.slice(0,24))); return true; } catch { return false; } };
  const status = document.createElement('div'); status.className='ei-status'; status.setAttribute('role','status'); document.body.append(status);
  let timer;
  const announce = text => { status.textContent=text; clearTimeout(timer); timer=setTimeout(()=>status.textContent='',3500); };
  const sync = () => { const saved=read('wishlist'); document.querySelectorAll('[data-ei-save]').forEach(button=>{ const active=saved.includes(button.dataset.eiSave); if(button.getAttribute('aria-pressed')!==String(active))button.setAttribute('aria-pressed',String(active)); if(button.classList.contains('ei-save')) { const icon=active?'♥':'♡'; if(button.textContent!==icon)button.textContent=icon; const title=button.closest('.ei-product-tile')?.querySelector('h3')?.textContent?.trim()||'this product'; button.setAttribute('aria-label',active?`Remove ${title} from wishlist`:`Save ${title} to wishlist`); } else { const label=active?'♥ Saved to wishlist':'♡ Save to wishlist'; if(button.textContent!==label)button.textContent=label; } }); };
  const pending = new WeakSet();
  async function renderList(section) {
    if(pending.has(section)) return;
    const kind=section.dataset.eiList;
    if((kind==='recent' && document.body.dataset.eirasRecent!=='true') || (kind==='wishlist' && document.body.dataset.eirasWishlist!=='true')) { section.hidden=true; return; }
    const current=document.querySelector('[data-ei-current]')?.dataset.eiCurrent;
    const handles=read(kind).filter(h=>kind!=='recent'||h!==current).slice(0,kind==='recent'?4:24);
    const grid=section.querySelector('[data-ei-list-grid]'); const note=section.querySelector('[data-ei-list-note]');
    if(!handles.length) { grid.replaceChildren(); note.hidden=false; if(kind==='recent'&&!window.Shopify?.designMode) section.hidden=true; return; }
    section.hidden=false; pending.add(section);
    try {
      const responses=await Promise.allSettled(handles.map(async handle=>{
        const response=await fetch(`${root}products/${encodeURIComponent(handle)}?view=eiras-card`,{credentials:'same-origin'});
        if(!response.ok) throw new Error('Product unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const tile=doc.querySelector('.ei-product-tile'); if(!tile) throw new Error('Product unavailable'); return tile;
      }));
      grid.replaceChildren(); responses.forEach(r=>{if(r.status==='fulfilled')grid.append(document.importNode(r.value,true));});
      note.hidden=!!grid.children.length;
      if(!grid.children.length) { note.textContent='These pieces are currently unavailable. Browse the collection to find something new.'; }
      sync();
    } finally { pending.delete(section); }
  }
  const recentObserved=new WeakSet();
  const recentObserver=typeof IntersectionObserver==='function'?new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){recentObserver.unobserve(entry.target);recentObserved.delete(entry.target);renderList(entry.target);}});},{rootMargin:'300px 0px'}):null;
  function queueList(section){
    if(section.dataset.eiList!=='recent'||!recentObserver){renderList(section);return;}
    if(recentObserved.has(section))return;
    recentObserved.add(section);recentObserver.observe(section);
  }
  function init(scope=document) {
    const current=scope.querySelector('[data-ei-current]')?.dataset.eiCurrent;
    if(current && document.body.dataset.eirasRecent==='true') save('recent',[current,...read('recent').filter(h=>h!==current)]);
    sync(); scope.querySelectorAll('[data-ei-list]').forEach(queueList);
  }
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-ei-save]'); if(!button)return;
    event.preventDefault(); const handle=button.dataset.eiSave; const saved=read('wishlist'); const exists=saved.includes(handle);
    if(!save('wishlist',exists?saved.filter(h=>h!==handle):[handle,...saved])) { announce('Your browser cannot save favourites. Enable local storage to use the wishlist.'); return; }
    sync(); announce(exists?'Removed from your wishlist':'Saved to your wishlist on this device'); document.querySelectorAll('[data-ei-list="wishlist"]').forEach(renderList);
  });
  document.addEventListener('shopify:section:load',event=>init(event.target));
  const cardsObserver = new MutationObserver(records=>{
    const addedCards=records.some(record=>record.target.closest?.('[data-ei-save]')||record.type==='attributes'||[...record.addedNodes].some(node=>node.nodeType===1&&(node.matches('[data-ei-save]')||node.querySelector('[data-ei-save]'))));
    if(addedCards)sync();
  });
  cardsObserver.observe(document.getElementById('MainContent')||document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['data-ei-save','aria-pressed']});
  window.addEventListener('storage',()=>init());
  init();
})();
/* Time-based easing for scroll-linked zoom. Native scrolling stays untouched. */
(()=>{
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const enabled=()=>document.body.dataset.eirasMotion==='true'&&!reduced.matches;
 const clamp=n=>Math.max(0,Math.min(1,n));
 const ease=n=>{n=clamp(n);return n*n*(3-2*n);};
 const tracks=new Map();let frame=0,lastTime=0,measureNeeded=true;
 const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');observer.unobserve(e.target);}}),{threshold:.06,rootMargin:'0px 0px 120px 0px'});
 function init(scope=document){
  scope.querySelectorAll('.ei-hero-track').forEach(el=>{if(!tracks.has(el))tracks.set(el,{hero:el.querySelector('.ei-hero'),current:0,target:0,ready:false});});
  if(enabled())scope.querySelectorAll('.ei-section-heading,.ei-category,.ei-coming,.ei-story-copy,.ei-newsletter,.ei-sample,.ei-brand-editorial .ei-story-image,.ei-edit-refined.ei-shop-section .ei-product-tile').forEach(el=>{if(el.dataset.eiReveal)return;el.dataset.eiReveal='true';el.classList.add('ei-reveal');observer.observe(el);});
  request();
 }
 function tick(time){
  frame=0;const dt=lastTime?Math.min(40,time-lastTime):16.67;lastTime=time;
  const active=enabled(),alpha=1-Math.exp(-dt/115);
  if(measureNeeded){tracks.forEach((state,el)=>{state.target=active?clamp(-el.getBoundingClientRect().top/Math.max(1,state.hero?.offsetHeight||1)):0;});measureNeeded=false;}
  let moving=false;
  tracks.forEach((state,el)=>{
   if(!el.isConnected){tracks.delete(el);return;}
   if(!state.ready||!active){state.current=state.target;state.ready=true;}else state.current+=(state.target-state.current)*alpha;
   const settling=active&&Math.abs(state.target-state.current)>.0002;
   if(!settling)state.current=state.target;
   moving ||= settling;
   const p=state.current;
   el.style.setProperty('--ei-zoom',(1+2.8*ease(p)).toFixed(4));
   el.style.setProperty('--ei-title-opacity',(1-ease((p-.12)/.76)).toFixed(4));
   el.style.setProperty('--ei-detail-opacity',(1-ease(p/.42)).toFixed(4));
   el.classList.toggle('ei-motion-active',settling);
  });
  if(moving&&!document.hidden)frame=requestAnimationFrame(tick);else lastTime=0;
 }
 function request(){measureNeeded=true;if(!frame&&!document.hidden)frame=requestAnimationFrame(tick);}
 document.addEventListener('scroll',request,{passive:true,capture:true});
 window.addEventListener('resize',request,{passive:true});
 document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(frame);frame=0;lastTime=0;}else request();});
 document.addEventListener('shopify:section:load',e=>init(e.target));
 document.addEventListener('shopify:section:unload',e=>{e.target.querySelectorAll('.ei-reveal').forEach(el=>observer.unobserve(el));tracks.forEach((_,el)=>{if(e.target.contains(el))tracks.delete(el);});});
 reduced.addEventListener('change',()=>{document.querySelectorAll('.ei-reveal').forEach(el=>el.classList.add('is-visible'));request();});
 init();
})();
(()=>{
 const observed=new WeakSet();
 const visibility=new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting})=>{target.classList.toggle('ei-corridor-paused',!isIntersecting||document.hidden||target.dataset.paused==='true');}),{threshold:0});
 function init(root=document){root.querySelectorAll('.ei-hero').forEach(hero=>{if(observed.has(hero))return;observed.add(hero);visibility.observe(hero);hero.querySelector('.ei-motion-toggle')?.addEventListener('click',e=>{const paused=hero.dataset.paused!=='true';hero.dataset.paused=String(paused);hero.classList.toggle('ei-corridor-paused',paused);e.currentTarget.setAttribute('aria-pressed',String(paused));e.currentTarget.textContent=paused?'Play motion':'Pause motion';});});}
 document.addEventListener('visibilitychange',()=>document.querySelectorAll('.ei-hero').forEach(h=>h.classList.toggle('ei-corridor-paused',document.hidden||h.dataset.paused==='true'||h.getBoundingClientRect().bottom<0)));
 document.addEventListener('shopify:section:load',e=>init(e.target));document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.ei-hero').forEach(h=>visibility.unobserve(h)));init();
})();

/* EIRAS editorial lookbook: native image transitions; no WebGL or external runtime. */
(()=>{
 const instances=new Map();
 function mount(hero){
  if(instances.has(hero))return;
  const pool = hero.querySelector('template[data-eiras-lookbook-pool]');
  if (pool) {
   const selected = eirasRandomSubset(pool.content.children, 5);
   if (selected.length) {
    hero.querySelectorAll('.ei-model-slide').forEach(slide => slide.remove());
    selected.forEach((slide, i) => {
     const clone = slide.cloneNode(true);
     if (i > 0) {
      clone.querySelectorAll('img').forEach(img => {
       for (const attr of ['srcset', 'src']) {
        const value = img.getAttribute(attr);
        if (value) { img.setAttribute(`data-eiras-${attr}`, value); img.removeAttribute(attr); }
       }
      });
     }
     if (i === 0) {
      const photo = clone.querySelector('.ei-model-photo img');
      if (photo) { photo.loading = 'eager'; photo.fetchPriority = 'high'; }
     }
     pool.before(clone);
    });
   }
  }
  const slides=[...hero.querySelectorAll('.ei-model-slide')];if(!slides.length)return;
  const nav=hero.querySelector('.ei-model-nav'),piece=hero.querySelector('.ei-model-piece'),count=hero.querySelector('.ei-model-count'),pause=hero.querySelector('.ei-model-pause');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)'),abort=new AbortController(),signal=abort.signal;
  const delay=Number(hero.dataset.delay)||7000;
  let current=0,timer=0,inView=true,paused=false,focused=false,dead=false,preloadTimer=0,changeVersion=0;
  function prepareSlide(slide) {
   return Promise.all([...slide.querySelectorAll('img')].map(img => {
    img.loading='eager';
    for(const attr of ['srcset','src']) {
     const value=img.getAttribute(`data-eiras-${attr}`);
     if(value){img.setAttribute(attr,value);img.removeAttribute(`data-eiras-${attr}`);}
    }
    if(img.complete)return Promise.resolve();
    return new Promise(resolve=>{
     img.addEventListener('load',resolve,{once:true,signal});
     img.addEventListener('error',resolve,{once:true,signal});
    });
   }));
  }
  function preloadNext() {
   clearTimeout(preloadTimer);
   const index=current;
   prepareSlide(slides[index]).then(()=>{
    if(dead||current!==index)return;
    preloadTimer=setTimeout(()=>{if(!dead&&current===index)prepareSlide(slides[(index+1)%slides.length]);},1000);
   });
  }
  function clear(){clearTimeout(timer);timer=0;}
  function schedule(){clear();if(!dead&&!paused&&!focused&&!reduced.matches&&inView&&!document.hidden&&slides.length>1)timer=setTimeout(()=>change((current+1)%slides.length),delay);}
  const buttons=slides.map((slide,i)=>{
   const button=document.createElement('button');button.type='button';button.className='ei-model-dot';button.setAttribute('aria-label',`Show ${slide.dataset.title}`);
   const img=document.createElement('img');img.src=slide.dataset.thumb;img.alt='';img.width=52;img.height=53;img.loading='lazy';button.append(img);
   button.addEventListener('click',()=>change(i),{signal});nav.append(button);return button;
  });
  function render(){
   slides.forEach((slide,i)=>{const active=i===current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));slide.inert=!active;buttons[i].setAttribute('aria-current',String(active));});
   piece.textContent=slides[current].dataset.title;piece.href=slides[current].dataset.link;
   count.textContent=`${String(current+1).padStart(2,'0')} / ${String(slides.length).padStart(2,'0')}`;
   preloadNext();
  }
  async function change(i){
   if(dead)return;
   const version=++changeVersion;clear();
   if(i===current){schedule();return;}
   await prepareSlide(slides[i]);
   if(dead||version!==changeVersion)return;
   current=i;render();schedule();
  }
  function activity(){hero.classList.toggle('is-paused',paused||reduced.matches||!inView||document.hidden);schedule();}
  pause.addEventListener('click',()=>{paused=!paused;pause.setAttribute('aria-pressed',String(paused));pause.textContent=paused?'Play motion':'Pause motion';if(!paused)focused=false;activity();},{signal});
  hero.addEventListener('focusin',()=>{focused=true;clear();},{signal});
  hero.addEventListener('focusout',e=>{if(!hero.contains(e.relatedTarget)){focused=false;schedule();}},{signal});
  nav.addEventListener('keydown',e=>{let next=current;if(e.key==='ArrowRight')next=(current+1)%slides.length;else if(e.key==='ArrowLeft')next=(current-1+slides.length)%slides.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=slides.length-1;else return;e.preventDefault();change(next);buttons[next].focus();},{signal});
  document.addEventListener('visibilitychange',activity,{signal});
  function motionPreference(){pause.disabled=reduced.matches;pause.textContent=reduced.matches?'Motion reduced':paused?'Play motion':'Pause motion';activity();}
  reduced.addEventListener('change',motionPreference,{signal});
  const observer=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;activity();},{threshold:.1});observer.observe(hero);
  instances.set(hero,()=>{dead=true;changeVersion++;abort.abort();clear();clearTimeout(preloadTimer);observer.disconnect();instances.delete(hero);});render();motionPreference();
 }
 function init(scope=document){scope.querySelectorAll('[data-eiras-lookbook]').forEach(mount);}
 document.addEventListener('shopify:section:load',e=>init(e.target));
 document.addEventListener('shopify:section:unload',e=>{instances.forEach((destroy,el)=>{if(e.target.contains(el))destroy();});});init();
})();
